/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminTeamSessionShort
 */
export interface OutputAdminTeamSessionShort {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeamSessionShort
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeamSessionShort
     */
    expiresAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeamSessionShort
     */
    finishedAt: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminTeamSessionShort
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeamSessionShort
     */
    status: string;
}

/**
 * Check if a given object implements the OutputAdminTeamSessionShort interface.
 */
export function instanceOfOutputAdminTeamSessionShort(value: object): boolean {
    if (!('createdAt' in value)) return false;
    if (!('expiresAt' in value)) return false;
    if (!('finishedAt' in value)) return false;
    if (!('id' in value)) return false;
    if (!('status' in value)) return false;
    return true;
}

export function OutputAdminTeamSessionShortFromJSON(json: any): OutputAdminTeamSessionShort {
    return OutputAdminTeamSessionShortFromJSONTyped(json, false);
}

export function OutputAdminTeamSessionShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminTeamSessionShort {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'expiresAt': json['expiresAt'],
        'finishedAt': json['finishedAt'],
        'id': json['id'],
        'status': json['status'],
    };
}

export function OutputAdminTeamSessionShortToJSON(value?: OutputAdminTeamSessionShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'expiresAt': value['expiresAt'],
        'finishedAt': value['finishedAt'],
        'id': value['id'],
        'status': value['status'],
    };
}

